export const getCurrentMonthValue = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
};

export const formatDateInputValue = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate(),
  ).padStart(2, "0")}`;
};

export const getCurrentMonthDateRange = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return {
    fechaInicio: formatDateInputValue(start),
    fechaFin: formatDateInputValue(end),
  };
};

export const validateReportDateRange = (fechaInicio, fechaFin) => {
  const startRaw = safeText(fechaInicio).trim();
  const endRaw = safeText(fechaFin).trim();

  if (!startRaw || !endRaw) {
    return "Debe seleccionar la fecha inicial y la fecha final.";
  }

  const start = new Date(`${startRaw}T00:00:00`);
  const end = new Date(`${endRaw}T00:00:00`);

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return "Las fechas ingresadas no son válidas.";
  }

  if (start > end) {
    return "La fecha inicial no puede ser mayor que la fecha final.";
  }

  const maxEnd = new Date(start);
  maxEnd.setFullYear(maxEnd.getFullYear() + 1);

  if (end > maxEnd) {
    return "El rango de fechas no puede ser mayor a un año.";
  }

  return "";
};

export const safeText = (value) => {
  if (value === undefined || value === null) return "";
  return String(value);
};

export const formatUsuarioReporte = (value, fallback = "") => {
  const raw = safeText(value).trim();
  if (raw) return raw.toUpperCase();
  const fb = safeText(fallback).trim();
  return fb ? fb.toUpperCase() : "";
};

const OFICINAS_ACTUALES_MAP = {
  1: "TEGUCIGALPA",
  2: "SAN PEDRO SULA",
  3: "LA CEIBA",
  4: "CHOLUTECA",
  5: "SANTA ROSA DE COPAN",
  6: "SANTA BARBARA",
  7: "JUTICALPA",
};

export const resolveReporteOfficeName = ({
  oficinaNombre,
  oficinaOrigen,
  oficinaId,
  oficinaKey,
} = {}) => {
  const origen = safeText(oficinaOrigen).trim().toUpperCase();
  const nombre = safeText(oficinaNombre).trim();
  let id = Number(oficinaId || 0);

  if ((!id || Number.isNaN(id)) && origen === "ACTUAL") {
    const key = safeText(oficinaKey).trim().toUpperCase();
    const match = key.match(/^ACTUAL-(\d+)$/);
    if (match) id = Number(match[1] || 0);
  }

  const fallback = origen === "ACTUAL" ? OFICINAS_ACTUALES_MAP[id] || "" : "";
  // En ACTUAL los registros guardan el id de oficina operativa (1..7);
  // usar este catálogo como fuente de verdad para evitar cruces con otras tablas.
  if (origen === "ACTUAL" && fallback) {
    return fallback;
  }
  const compact = nombre.replace(/\s+/g, "").toUpperCase();
  const numericLike = /^\d+$/.test(compact);
  const idText = String(Number(id || 0));
  const numericAlias = compact === idText || compact === `${idText}(ACTUAL)`;

  if (fallback && (!nombre || numericLike || numericAlias)) {
    return fallback;
  }
  return nombre || fallback || "SIN OFICINA";
};

export const isSinOficinaReporte = ({
  oficinaNombre,
  oficinaOrigen,
  oficinaKey,
  oficinaId,
} = {}) => {
  const origen = safeText(oficinaOrigen).trim().toUpperCase();
  const key = safeText(oficinaKey).trim().toUpperCase();
  const resolvedName = resolveReporteOfficeName({
    oficinaNombre,
    oficinaOrigen,
    oficinaId,
    oficinaKey,
  }).trim().toUpperCase();

  return (
    origen === "SIN_DATOS" ||
    key === "SIN-OFICINA" ||
    resolvedName === "SIN OFICINA"
  );
};

export const formatIsoDateToEs = (value) => {
  const raw = safeText(value).trim();
  if (!raw) return "";
  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!iso) return raw;
  const months = [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic",
  ];
  const monthIdx = Number(iso[2]) - 1;
  const monthLabel = months[monthIdx] || iso[2];
  return `${iso[3]}/${monthLabel}/${iso[1]}`;
};

export const parseOficinaSelector = (value) => {
  const raw = safeText(value).trim();
  if (!raw || raw === "TODAS") return { oficinaTipo: "TODAS", oficinaId: "" };
  const [tipo, id] = raw.split(":");
  const normalizedType = safeText(tipo).trim().toUpperCase();
  const normalizedId = safeText(id).trim();
  if (!normalizedType || !normalizedId) return { oficinaTipo: "TODAS", oficinaId: "" };
  return { oficinaTipo: normalizedType, oficinaId: normalizedId };
};

export const openHtmlPrintWindow = (htmlContent) => {
  const popup = window.open("", "_blank", "width=1200,height=900");
  if (!popup) return false;
  popup.document.open();
  popup.document.write(htmlContent);
  popup.document.close();
  return true;
};
